import NumberSupport from 'sharedreact/utils/NumberSupport';

function isNumber (valueString: string): boolean {
  return NumberSupport.isNumber(valueString);
}

function isNumberGreaterThanOrEqualTo (valueString: string, greaterThanOrEqualTo: number, precision: number = NumberSupport.defaultPrecision): boolean {
  const value: number | null = NumberSupport.stringToNumber(valueString, precision);

  if (value != null) {
    return NumberSupport.isGreaterThanOrEqualTo(value, greaterThanOrEqualTo, precision);
  }
  return false;
}

function isNumberGreaterThan (valueString: string, greaterThan: number, precision: number = NumberSupport.defaultPrecision): boolean {
  const value: number | null = NumberSupport.stringToNumber(valueString, precision);

  if (value != null) {
    return NumberSupport.isGreaterThan(value, greaterThan, precision);
  }
  return false;
}

function isNumberLessThanOrEqualTo (valueString: string, lessThanOrEqualTo: number, precision: number = NumberSupport.defaultPrecision): boolean {
  const value: number | null = NumberSupport.stringToNumber(valueString, precision);

  if (value != null) {
    return NumberSupport.isLessThanOrEqualTo(value, lessThanOrEqualTo, precision);
  }
  return false;
}

function isNumberLessThan (valueString: string, lessThan: number, precision: number = NumberSupport.defaultPrecision): boolean {
  const value: number | null = NumberSupport.stringToNumber(valueString, precision);

  if (value != null) {
    return NumberSupport.isLessThan(value, lessThan, precision);
  }
  return false;
}

const NumberValidators = {
  isNumber,
  isNumberGreaterThanOrEqualTo,
  isNumberGreaterThan,
  isNumberLessThanOrEqualTo,
  isNumberLessThan
};

export {
  isNumber,
  isNumberGreaterThanOrEqualTo,
  isNumberGreaterThan,
  isNumberLessThanOrEqualTo,
  isNumberLessThan
};

export default NumberValidators;
